import React from 'react';
import './ItemList.css';

function ItemList({ items, onItemClick, selectedItem, selectedInfo }) {
  return (
    <>
      <div className="item-list">
        {items.map(item => (
          <div 
            key={item.id}
            className={`item ${selectedItem && selectedItem.id === item.id ? 'selected' : ''} ${item.no_prerequisites ? 'no-prerequisites' : ''} ${item.end === 'T' ? 'end-date-t' : ''}`}
            onClick={() => onItemClick(item)}
          >
            {item.name}
          </div>
        ))}
      </div>

    </>
  );
}

export default ItemList;